export let promoCodes = {
  paging: {
    total: 112,
    count: 10,
    totalPages: 12,
    currentPage: 0,
  },
  promoCodes: [
    {
      promoCodeId: '2fa1375a-e452-4013-ab21-1925ce156182',
      title: 'AA',
      code: 'AA',
      shortDescription: 'AA',
      longDescription: 'AA',
      icon: null,
      externalId: null,
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: null,
      beaconName: null,
    },
    {
      promoCodeId: '3422befb-b615-4b3d-a156-5c9895b2884d',
      title: 'AAM',
      code: 'AAM',
      shortDescription: 'AAM',
      longDescription: null,
      icon: null,
      externalId: null,
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: null,
      beaconName: null,
    },
    {
      promoCodeId: '5b281060-80c7-4a0e-beac-0792edcd978f',
      title: 'ABC',
      code: 'ABC',
      shortDescription: 'ABC',
      longDescription: 'ABC',
      icon: null,
      externalId: null,
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: null,
      beaconName: null,
    },
    {
      promoCodeId: '40a1de84-0954-4e34-9fa3-121dba9a3cc7',
      title: 'ABC 2',
      code: 'abc',
      shortDescription: 'abc',
      longDescription: 'abc',
      icon: null,
      externalId: null,
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: '06f862a8-be8b-48f6-a405-76420b35135a:1:1',
      beaconName: 'Hollywood Burger',
    },
    {
      promoCodeId: '3c5d03f0-d6e5-49b7-8ab6-b34304897a5a',
      title: 'ASD',
      code: 'ASD',
      shortDescription: 'ASD',
      longDescription: null,
      icon: null,
      externalId: null,
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: null,
      beaconName: null,
    },
    {
      promoCodeId: 'f7f9e60c-30df-4089-ad2b-3537e4a6d85e',
      title: 'AUTOTAGGER',
      code: 'AUTOTAGGER',
      shortDescription: 'ttest auto tager promo',
      longDescription: 'ttest auto tager promo - long',
      icon: null,
      externalId: '1212',
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: null,
      beaconName: null,
    },
    {
      promoCodeId: '442a6b89-f139-4da7-83a4-0e80bd090924',
      title: 'Bootapp',
      code: 'Bootapp',
      shortDescription: 'ccccc',
      longDescription: null,
      icon: '',
      externalId: null,
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: null,
      beaconName: null,
    },
    {
      promoCodeId: '2fcf11af-2b98-426a-8e0e-fa2069f31868',
      title: 'CHECKIN',
      code: 'CHECKIN',
      shortDescription: 'Points',
      longDescription: 'Points',
      icon: null,
      externalId: null,
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: null,
      beaconName: null,
    },
    {
      promoCodeId: 'f99f9d40-770f-4c2f-a883-0cace15eeca4',
      title: 'CHKSMS',
      code: 'CHKSMS',
      shortDescription: 'CHKSMS',
      longDescription: 'CHKSMS',
      icon: null,
      externalId: null,
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: null,
      beaconName: null,
    },
    {
      promoCodeId: '5440c10f-5e6b-40f5-820b-71a2acd949db',
      title: 'CJM',
      code: 'CJM',
      shortDescription: 'CJM',
      longDescription: 'CJM',
      icon: null,
      externalId: null,
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: null,
      beaconName: null,
    },
  ],
};

export let createPromoCode = {
  promoCodeId: '34635d8b-b72c-438f-9a37-f918bfa9ec19',
};

export let getPromoCode = {
  promoCodeId: '2fa1375a-e452-4013-ab21-1925ce156182',
  title: 'AA',
  code: 'AA',
  shortDescription: 'AA',
  longDescription: 'AA',
  icon: null,
  externalId: null,
  merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
  beaconId: null,
  beaconName: null,
};
